<template>
    <div class="wrapper">
        <h1>Glossar</h1>
        <section class="u-mt--medium">
            <input v-model="searchQuery" @keyup="filterChar = 'search'" type="text" placeholder="Suchen">
                    <button class="input-icon" @click="filterChar = 'search'" :class="{active: filterChar == 'search'}"><i class="fas fa-search"></i></button>
        </section>
        <div v-if="checkGray"></div>
        <section class="u-mt--medium">
            <div class="filter filter--narrow">
                <a @click="filterChar = null; scrollToTop()" :class="{active: filterChar == null}">Alle</a>
                <a @click="filterChar = '#'; scrollToTop()" :class="[{active: filterChar == '#'},{gray: checkGray('#')}]">#</a>
                <a @click="filterChar = 'A'; scrollToTop()" :class="[{active: filterChar == 'A'},{gray: checkGray('A')}]">A</a>
                <a @click="filterChar = 'B'; scrollToTop()" :class="[{active: filterChar == 'B'},{gray: checkGray('B')}]">B</a>
                <a @click="filterChar = 'C'; scrollToTop()" :class="[{active: filterChar == 'C'},{gray: checkGray('C')}]">C</a>
                <a @click="filterChar = 'D'; scrollToTop()" :class="[{active: filterChar == 'D'},{gray: checkGray('D')}]">D</a>
                <a @click="filterChar = 'E'; scrollToTop()" :class="[{active: filterChar == 'E'},{gray: checkGray('E')}]">E</a>
                <a @click="filterChar = 'F'; scrollToTop()" :class="[{active: filterChar == 'F'},{gray: checkGray('F')}]">F</a>
                <a @click="filterChar = 'G'; scrollToTop()" :class="[{active: filterChar == 'G'},{gray: checkGray('G')}]">G</a>
                <a @click="filterChar = 'H'; scrollToTop()" :class="[{active: filterChar == 'H'},{gray: checkGray('H')}]">H</a>
                <a @click="filterChar = 'I'; scrollToTop()" :class="[{active: filterChar == 'I'},{gray: checkGray('I')}]">I</a>
                <a @click="filterChar = 'J'; scrollToTop()" :class="[{active: filterChar == 'J'},{gray: checkGray('J')}]">J</a>
                <a @click="filterChar = 'K'; scrollToTop()" :class="[{active: filterChar == 'K'},{gray: checkGray('K')}]">K</a>
                <a @click="filterChar = 'L'; scrollToTop()" :class="[{active: filterChar == 'L'},{gray: checkGray('L')}]">L</a>
                <a @click="filterChar = 'M'; scrollToTop()" :class="[{active: filterChar == 'M'},{gray: checkGray('M')}]">M</a>
                <a @click="filterChar = 'N'; scrollToTop()" :class="[{active: filterChar == 'N'},{gray: checkGray('N')}]">N</a>
                <a @click="filterChar = 'O'; scrollToTop()" :class="[{active: filterChar == 'O'},{gray: checkGray('O')}]">O</a>
                <a @click="filterChar = 'P'; scrollToTop()" :class="[{active: filterChar == 'P'},{gray: checkGray('P')}]">P</a>
                <a @click="filterChar = 'Q'; scrollToTop()" :class="[{active: filterChar == 'Q'},{gray: checkGray('Q')}]">Q</a>
                <a @click="filterChar = 'R'; scrollToTop()" :class="[{active: filterChar == 'R'},{gray: checkGray('R')}]">R</a>
                <a @click="filterChar = 'S'; scrollToTop()" :class="[{active: filterChar == 'S'},{gray: checkGray('S')}]">S</a>
                <a @click="filterChar = 'T'; scrollToTop()" :class="[{active: filterChar == 'T'},{gray: checkGray('T')}]">T</a>
                <a @click="filterChar = 'U'; scrollToTop()" :class="[{active: filterChar == 'U'},{gray: checkGray('U')}]">U</a>
                <a @click="filterChar = 'V'; scrollToTop()" :class="[{active: filterChar == 'V'},{gray: checkGray('V')}]">V</a>
                <a @click="filterChar = 'W'; scrollToTop()" :class="[{active: filterChar == 'W'},{gray: checkGray('W')}]">W</a>
                <a @click="filterChar = 'X'; scrollToTop()" :class="[{active: filterChar == 'X'},{gray: checkGray('X')}]">X</a>
                <a @click="filterChar = 'Y'; scrollToTop()" :class="[{active: filterChar == 'Y'},{gray: checkGray('Y')}]">Y</a>
                <a @click="filterChar = 'Z'; scrollToTop()" :class="[{active: filterChar == 'Z'},{gray: checkGray('Z')}]">Z</a>
            </div>
        </section>
        <section class="u-mt--small">
            <div class="grid">
                <div class="col-9">
                    <div v-for="phrase in filteredPhrases" :key="phrase.id" class="textPhrase">
                        <span :id="phrase.slug" class="scrollAnchor"></span>
                        <h2>{{ phrase.title }}</h2>
                        <div v-html="phrase.text"></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Fuse from 'fuse.js'

    export default {
        data: function(){
            return {
                filterChar: null,
                searchQuery: null
            }
        },
        computed: {
            glossary(){
                return this.$store.state.glossary.glossary
            },
            filteredPhrases(){
                let glossary = this.glossary
                let filterChar = this.filterChar
                let searchQuery = this.searchQuery


                if (!filterChar){
                    return glossary
                } else if (filterChar == "search") {
                    let options = {shouldSort: true,
                        keys: [
                            "title",
                            "text"
                        ]
                    }
                    let fuse = new Fuse(glossary, options)
                    let results = fuse.search(searchQuery)
                    if (searchQuery.length) {
                        return results
                    } else {
                        return glossary
                    }
                } else {
                    if(filterChar == "#"){
                      let numberarray = ["0","1","2","3","4","5","6","7","8","9",0,1,2,3,4,5,6,7,8,9]
                      return glossary.filter(phrase => numberarray.includes(phrase.title[0]))
                    }
                    return glossary.filter(phrase => phrase.title[0] == filterChar)
                }
            }
        },
        methods: {
          checkGray: function(checkChar){
            let glossary = this.glossary
            if(checkChar == "#") {
              let numberarray = ["0","1","2","3","4","5","6","7","8","9",0,1,2,3,4,5,6,7,8,9]
              if(glossary.filter(phrase => numberarray.includes(phrase.title[0])) == 0) {
                return true
              } else {
                return false
              }
            }
            if(glossary.filter(phrase => phrase.title[0] == checkChar) == 0) {
                return true
            } else {
                return false
            }
          },
          scrollToTop() {
              window.scrollTo(0,0);
          },
          scrollCheck() {
            window.onscroll = function() {
                if(window.scrollY > 480) {
                    document.getElementsByClassName("filter")[0].classList.add("fixed")
                } else {
                    document.getElementsByClassName("filter")[0].classList.remove("fixed")
                }
            }
          }
        },
        beforeMount() {
          this.checkGray()
        },
        created: function() {
          this.scrollCheck()
        },
        mounted: function() {
          this.scrollCheck()
        },
        updated: function() {
          this.scrollCheck()
          this.$nextTick(() => {
            if(this.$route.hash) {
              const el = document.querySelector(this.$route.hash);
              el && el.scrollIntoView();
            }
          })
        },
        beforeRouteUpdate() {
          this.filterChar = null;
        }
    }
</script>

<style scoped lang="scss">
    .filter .gray {
        color: #93aec5;
        pointer-events: none;
    }

    .fixed {
        position: fixed;
        background-color: white;
        top: 0;
        width: 100%;
        padding: 20px;
        z-index: 1;
    }

    .textPhrase {
        position: relative;
    }

    .scrollAnchor {
        position: absolute;
        top: -150px;
        display: block;
    }

    @media (max-width: 1620px) {
        .scrollAnchor {
            top: -180px;
        }
    }

    @media (max-width: 1175px) {
        .scrollAnchor {
            top: -220px;
        }
    }

    @media (max-width: 1000px) {
        .filter {
            top: 134px;
            left: 0;
        }
        .scrollAnchor {
            top: -350px;
        }
    }
    @media (max-width: 650px) {
        .scrollAnchor {
            top: -450px;
        }
    }
    @media (max-width: 440px) {
        .scrollAnchor {
            top: -500px;
        }
    }
    @media (max-width: 350px) {
        .scrollAnchor {
            top: -550px;
        }
    }
</style>
